// ============================================================================
// debug.js — F3 overlay: FPS, frame/logic ms, active entities, draw calls,
// triangles, LOD breakdown and spawn/steps counters. Reads a stats object the
// main loop fills each frame. Off by default.
// ============================================================================

import { LOD_FULL, LOD_STEER, LOD_STAT } from '../core/constants.js';

export class DebugOverlay {
  constructor(hudRoot) {
    this.el = document.createElement('div');
    this.el.style.cssText = `position:fixed;left:14px;top:14px;z-index:30;display:none;
      font:12px/1.5 'SFMono-Regular',Consolas,monospace;color:#9effa0;
      background:rgba(0,0,0,.6);border:1px solid rgba(120,255,140,.25);padding:8px 12px;white-space:pre;pointer-events:none;`;
    hudRoot.appendChild(this.el);
    this.visible = false;
    window.addEventListener('keydown', (e) => {
      if (e.code === 'F3') { e.preventDefault(); this.visible = !this.visible; this.el.style.display = this.visible ? 'block' : 'none'; }
    });
    this._acc = 0; this._frames = 0; this._fps = 0; this._t = 0;
  }

  update(world, stats, frameDt) {
    this._acc += frameDt; this._frames++;
    if (this._acc >= 0.4) { this._fps = this._frames / this._acc; this._acc = 0; this._frames = 0; }
    if (!this.visible) return;
    this._t += frameDt;
    if (this._t < 0.12) return; // throttle DOM writes
    this._t = 0;

    // LOD tally
    let full = 0, steer = 0, stat = 0, magmar = 0, ally = 0;
    const units = world.units.active;
    for (let i = 0; i < units.length; i++) {
      const u = units[i];
      if (u.lod === LOD_FULL) full++; else if (u.lod === LOD_STEER) steer++; else stat++;
      if (u.team === 0) ally++; else magmar++;
    }

    const ms = (v) => v.toFixed(2);
    this.el.textContent =
`TITANLORD · debug [F3]
fps        ${this._fps.toFixed(0)}   frame ${ms(frameDt * 1000)}ms
logic      ${ms(stats.logicMs)}ms  render ${ms(stats.renderMs)}ms  steps ${stats.steps}
draw calls ${stats.drawCalls}   tris ${(stats.tris / 1000).toFixed(1)}k
units      ${units.length}  (magmar ${magmar} / ally ${ally})
lod        full ${full}  steer ${steer}  stat ${stat}
sparks     ${world.sparks.count}  dmg ${world.dmgnums.count}  bolts ${world.projectiles.count}
shockwaves ${world.shockwaves.filter(w=>w.active).length}
morale     ${world.morale.toFixed(1)}   kills ${world.killCount}
player     hp ${world.player.hp.toFixed(0)} titan ${world.player.titan.toFixed(0)} st:${world.player.state}`;
  }
}
